import {
  ImageSettings,
  ImageSuiteAppProps,
  ModelImageDall_EName,
  ModelImageFluxName,
  ModelImageFXName,
  ModelImageGptImageName,
  ModelImageGrokName,
} from "../../../../Helper";
import { Box, Typography } from "@mui/material";
import { InputText } from "../Shared/InputText";
import { SuiteAppSettings } from "../Shared/SuiteAppSettings";
import { AppActionButton } from "../Shared/AppActionButton";
import { OutputImage } from "../Shared/OutputImage";
import "../../../SharedSuite/Suites.css";
import SignalRService from "../../../one-query/services/SignalRService";
import { useGenerateMicroPeopleImage } from "../../../../store/Apis/SuitesApps/ImageSuitesApi";
import { useEffect } from "react";
import { useAppSelector } from "../../../../store/hooks";
import { UploadImageModal } from "../Shared/UploadImageModal";
import { appContainerStyle, appInputOutputContainerStyle } from "../Shared/styles";

export const MicroPeopleApp = ({
  example,
  imageSettings,
  handelGenerateRandomPrompt,
  IsGeneratePromptLoading,
  isGenerateButtonDisabled,
  generatedPrompt,
  generatedImg,
  isGenerateImgLoading,
  selectedModel,
  selectedSize,
  seed,
  toggleLockSeed,
  openLockSeed,
  getErrorMessage,
  setSelectedModel,
  setSelectedSize,
  inputValue,
  setInputValue,
  handleOpenExpandImage,
  handleSetIsLoading,
  handleClearInput,
  handleInputImageChange,
  inputImageValue,
  handelImprovePrompt,
  isImagePromptImproving,
  creditsNeeded
}: ImageSuiteAppProps) => {
  const appSuiteCosts = useAppSelector((s) => s.User.AppSuiteCosts);
  const {
    mutate: GenerateMicroPeopleImage,
    isPending: IsGenerateMicroPeopleImage,
    error,
  } = useGenerateMicroPeopleImage();

  useEffect(() => {
    if (error) getErrorMessage(error);
  }, [error]);

  useEffect(() => {
    if (IsGenerateMicroPeopleImage) {
      handleSetIsLoading(true);
    }
  }, [IsGenerateMicroPeopleImage]);

  const handleGenerateImage = async (
    inputValue: string,
    selectedModel: string,
    selectedSize: string,
    referenceImage: File
  ) => {
    if (inputValue && inputValue?.trim() !== "") {
      const connectionId = await SignalRService.getInstance().getConnectionId();

      const RequestData = {
        prompt: inputValue,
        connectionId: connectionId,
        modelName: selectedModel,
        imageRatio: selectedSize,
        image: referenceImage,
      };
      GenerateMicroPeopleImage(RequestData);
    }
  };

  const handleSelectModel = (model: string) => {
    setSelectedModel(model);
  };

  const handleSelectSize = (size: string) => {
    setSelectedSize(size);
  };

  const handleGenerationAction = () => {
    if (inputValue && selectedModel && selectedSize) {
      handleGenerateImage(
        inputValue,
        selectedModel,
        selectedSize,
        inputImageValue
      );
    }
  };

  // Handle show only gpt image & Flux & dallE models in selection models.
  const filteredMicroPeopleSettings: ImageSettings | undefined = imageSettings
    ? {
      ...imageSettings,
        imageModels: imageSettings.imageModels.filter(
          (model) => model.modelName === ModelImageGptImageName
        ),
      }
    : undefined;
  return (
    <Box sx={appContainerStyle}>
        <Box className="image-suites-input-header">
          <Typography className="image-suites-input-header-title">
            Transform into a tiny character with just one tap!{" "}
          </Typography>
        </Box>
        <Box sx={appInputOutputContainerStyle}>
          <Box className="image-suites-input micro-people-app">
            <Box className="image-suites-input-failed">
              <Typography className="settings-title">Prompt</Typography>
              <InputText
                example={example}
                setInputValue={setInputValue}
                inputValue={inputValue}
                handelGenerateRandomPrompt={handelGenerateRandomPrompt}
                IsGeneratePromptLoading={IsGeneratePromptLoading}
                isGenerateImgLoading={isGenerateImgLoading}
                generatedPrompt={generatedPrompt}
                handelImprovePrompt={handelImprovePrompt}
                isImprovePromptDisabled={isImagePromptImproving}
              />
              <Box sx={{marginTop: "16px"}}>
              <UploadImageModal
                inputValue={inputImageValue??example.path}
                handleClearInput={handleClearInput}
                isGenerateImgLoading={isGenerateImgLoading}
                handleInputImageChange={handleInputImageChange}
                appTitle="Reference image"
                appDesc="For best results, use a PNG image with a transparent background."
              />
              </Box>
              <SuiteAppSettings
                imageSettings={filteredMicroPeopleSettings}
                handleSelectModel={handleSelectModel}
                handleSelectSize={handleSelectSize}
                selectedModel={selectedModel}
                selectedSize={selectedSize}
                toggleLockSeed={toggleLockSeed}
                openLockSeed={openLockSeed}
                seedValue={seed}
                showSetting={{ models: true, dimensions: true, seed: true }}
              />
            </Box>
            <AppActionButton
              creditsCount = {creditsNeeded ?? 0}
              appMethodFire={handleGenerationAction}
              isGenerateButtonDisabled={isGenerateButtonDisabled}
              IsGeneratePromptLoading={IsGeneratePromptLoading}
              inputValue={inputValue}
            />
          </Box>
          <Box className="image-suites-output">
            <Box className="image-suites-output-result">
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <Typography className="image-suites-output-result-placeholder">
                  {isGenerateImgLoading || generatedImg ? "Output":"Sample Output"}
                </Typography>
                <OutputImage
                  slider={false}
                  outputImage={true}
                  imgUrl={generatedImg}
                  exampleImgUrl={example.path}
                  isLoading={isGenerateImgLoading}
                  handleOpenExpandImage={handleOpenExpandImage}
                />
              </Box>
            </Box>
          </Box>
        </Box>
    </Box>
  );
};
